<template>
    <v-footer class="level1-z-index" dark id="app-footer">
        <v-spacer/>
        <div><a href="https://www.wsl.ch/de/index.html" :title="$t('title.wsl')" target="_blank"> &copy; {{
            $t('structure.wsl') }} </a> | {{ new Date().getFullYear() }}
        </div>
    </v-footer>
</template>

<script>
    export default {
        name: 'ApplicationFooter',
        computed: {
            screenSize() {
                // set footer position style attribute to avoid overlapping in mobile setting
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs':
                        return 'mobile'
                    case 'sm':
                        return 'mobile'
                    case 'md':
                        return 'normal'
                    case 'lg':
                        return 'normal'
                    case 'xl':
                        return 'normal'
                    default:
                        return 'normal'
                }
            },
        },
        watch: {
            screenSize() {
                this.setScreenSize()
            }
        },
        methods: {
            //set footer position style attribute to avoid overlapping in mobile setting
            setScreenSize() {
                if (this.screenSize === 'mobile') {
                    document.getElementById('app-footer').style.marginTop = '60px'
                    document.getElementById('app-footer').style.position = ''
                } else {
                    document.getElementById('app-footer').style.marginTop = '60px'
                }
            }

        },
        mounted() {
            this.setScreenSize()
        }

    }
</script>


<style scoped lang="scss">
    @import '../../../global';

    a {
        color: inherit !important; // avoid link coloring on dark footer
        text-decoration: none;
    }

    #app-footer {
        background-color: $app-black;
        left: 0;
        right: 0;
        bottom: 0;
        margin-top: 50px;
    }

</style>
